import { Link } from 'react-router';
import { Controller, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';

import { Button } from '@/components/ui/button';
import {
  Field,
  FieldError,
  FieldGroup,
  FieldLabel,
} from '@/components/ui/field';
import { Input } from '@/components/ui/input';
import { forgotPasswordSchema, ForgotPasswordInput } from './schema';

interface Props {
  onSubmit: (data: ForgotPasswordInput) => void;
}

export default function ResetPasswordForm({ onSubmit }: Props) {
  const form = useForm({
    defaultValues: {
      email: '',
    },
    resolver: zodResolver(forgotPasswordSchema),
  });

  return (
    <form
      className="flex flex-col gap-6"
      onSubmit={form.handleSubmit(onSubmit)}
    >
      <FieldGroup>
        <Controller
          control={form.control}
          name="email"
          render={({ field, fieldState }) => (
            <Field data-invalid={fieldState.invalid}>
              <div className="flex flex-wrap items-center justify-between gap-1">
                <FieldLabel htmlFor={field.name}>Work Email</FieldLabel>
                <Link className="text-primary text-sm hover:underline" to="/">
                  Back to login
                </Link>
              </div>
              <Input
                {...field}
                aria-invalid={fieldState.invalid}
                autoCapitalize="off"
                autoComplete="email"
                autoCorrect="off"
                autoFocus
                data-testid="email-input"
                id={field.name}
                type="email"
              />
              {fieldState.invalid && <FieldError errors={[fieldState.error]} />}
            </Field>
          )}
        />
      </FieldGroup>
      <Button data-testid="submit-button" type="submit">
        Submit
      </Button>
    </form>
  );
}
